import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ExperiencePage } from './pages/ExperiencePage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="font-sans text-ink bg-light min-h-screen selection:bg-gold/30 selection:text-navy-900" data-id="element-1">
        <Navbar data-id="element-2" />
        <main data-id="element-3">
          <AnimatePresence mode="wait" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
              <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
              <Route path="/experience" element={<ExperiencePage data-id="element-11" />} data-id="element-10" />
              <Route path="/projects" element={<ProjectsPage data-id="element-13" />} data-id="element-12" />
              <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
            </Routes>
          </AnimatePresence>
        </main>
        <Footer data-id="element-16" />
      </div>
    </BrowserRouter>;
}